import { render, staticRenderFns } from "./DotsSettingsMenu.vue?vue&type=template&id=0a501904&"
import script from "./DotsSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./DotsSettingsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports